function ClientViewEditForm($rootDom) {
    var form = new ClientForm($rootDom);
    var popup = new ClientPopup($rootDom);

    var m = {
        init: function() {
            form.disable();

            m.setViewClient();
            m.onClickEdit();

            popup.init();
        },

        onClickEdit: function() {
            $('.addressbook-btnedit').on('click', function(e) {
                form.enable();
                form.disableOrg();
                m.setEditClient();
                popup.setHeight();
                $(this).hide();
            });
        },

        setEditClient: function() {
            $rootDom.find('.addressbook-btnedit').hide();
            $rootDom.find('.addressbook-title').html('EDIT CLIENT');
            $rootDom.find('.addressbook-popup__buttonwrap').show();

            form.initListeners();
        },

        setViewClient: function() {
            $rootDom.find('.addressbook-btnedit').show();
            $rootDom.find('.addressbook-title').html('VIEW CLIENT');
            $rootDom.find('.addressbook-popup__buttonwrap').hide();
        },
    };

    return m;
}
